import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import Modal from "react-responsive-modal";
import AssignCapsuleModalContent from '../Home/AssignCapsuleModalContent';
import userProfilImage from '../assets/icon_user_profile.svg';
import "./ReactiveCard.css";
import { Collapse } from '@material-ui/core';

const styles_desktop = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
    },
    modal: {
        boxShadow: 'none',
        borderRadius: '4px',
        minHeight: "601px",
        maxWidth: "395px",
        top: "10%",
        padding: "0px",
    }
};

const styles_mobile = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
        padding: "0px",
    },
    modal: {
        boxShadow: 'none',
        minHeight: "100%",
        width: "100%",
        padding: "0px",
    }
};


const INITIAL_STATE = {
    assignCapsuleOpen: false,
    originPicture: '',
    originFirstname: '',
    originLastname: '',
    originPosition: '',
    error: null,
};

class ReactiveCard extends Component {

    render() {
        return (
            <ReactiveCardComponent {...this.props} />
        );
    }
}


class ReactiveCardComponentBase extends Component {

    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    async componentDidMount() {
        const fromId = this.props.from;
        let doc = await this.props.firebase.db.collection('users').doc(fromId).get()

        const originPicture = doc.data().image_url_profile;
        const originFirstname = doc.data().firstname;
        const originLastname = doc.data().lastname;
        const originPosition = doc.data().position;

        this.setState({ originPicture, originFirstname, originLastname, originPosition });
    }

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    addressCapsule = () => {

        this.openAssignCapsule();
    };

    openAssignCapsule = () => {
        this.setState({
            assignCapsuleOpen: true
        })
    }

    closeAssignCapsule = () => {
        this.setState({
            assignCapsuleOpen: false
        })
    }


    render() {
        const title = this.props.title || 'Default';
        const cardIndex = this.props.cardIndex || 0;
        const addressedTo = this.props.addressedTo || 'Default';
        const nbPolls = this.props.nbPolls || 0;
        const nbIdeas = this.props.nbIdeas || 0;
        const nbLikes = this.props.nbLikes || 0;
        const tagList = this.props.tagList || [];
        const picture = this.props.picture || require('../../assets/example-productivity.jpg');
        const { capsuleID, active, timeEstimation, importanceEstimation } = this.props;
        const { originPicture, originFirstname, originLastname, originPosition } = this.state;
        var addressedText = '';

        if (addressedTo !== 'Default') {
            addressedText = 'Acceptée par ' + addressedTo;
        }
        const tagDisplay = [];

        if (tagList !== []) {
            if (tagList.lenght < 2) {
                for (const [index, value] of tagList.entries()) {
                    tagDisplay.push(
                        <div className="reactive-card-tag" key={index}>#{value}</div>
                    )
                }
            }
            else {
                for (const [index, value] of tagList.slice(0, 2).entries()) {
                    tagDisplay.push(
                        <div className="reactive-card-tag" key={index}>#{value}</div>
                    )
                }
            }
        }

        return (
            <>
                <div className={active ? "active-card card" : "inactive-card card"} >

                    <img className="card-img-top img-cropper" src={picture} alt="Card" />

                    <div className="reactive-card-header">
                        <div className="reactive-card-title">{title}</div>
                        <div className="card-index-container">{cardIndex}</div>
                    </div>

                    <img className="reactive-card-bottom-background" src={require('../../assets/cards/card_white_no_shape.svg')} alt="Bottom" />

                    <div className="reactive-card-body">
                        <p className="reactive-card-adressing-text">{addressedText}</p>
                        <p className="reactive-card-other-text">{nbPolls} {(nbPolls === 1) ? 'sondage' : 'sondages'}</p>
                        <p className="reactive-card-other-text">{nbIdeas} {(nbIdeas === 1) ? 'idée' : 'idées'}</p>

                        <div className="reactive-card-footer">
                            <div className="size-tag-container">
                                {tagDisplay}
                            </div>
                            <div className="reactive-card-like-container">
                                <div className="reactive-card-like-text mr-2">{nbLikes}</div>
                                <img src={require('../../assets/cards/icon_card_like.svg')} alt="Like" />
                            </div>
                        </div>
                    </div>

                    <Modal
                        open={this.state.assignCapsuleOpen}
                        onClose={this.closeAssignCapsule}
                        center
                        showCloseIcon={true}
                        styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
                    >
                        <AssignCapsuleModalContent
                            onClose={this.closeAssignCapsule}
                            capsuleID={capsuleID} />

                    </Modal>
                </div>

                <Collapse in={active}>
                    <div className="active-card-footer">
                        <div className="active-card-footer-text"> Adressée par :</div>
                        <div className="active-card-origin-visualization">
                            <div className="active-card-origin" >
                                <img
                                    className="active-card-origin-picture"
                                    src={originPicture !== null ? originPicture : userProfilImage}
                                    alt='origin'
                                ></img>
                                <div>
                                    <div className="active-card-name">{originFirstname} {originLastname}</div>
                                    <div className="active-card-position" >{originPosition}</div>
                                </div>
                            </div>
                        </div>
                        <div className="active-card-details">
                            <div className="active-card-details-text"><b>Importance :</b> {importanceEstimation}</div>
                            <div className="active-card-details-text"><b>Délai :</b> {timeEstimation}</div>
                        </div>
                    </div>
                </Collapse>
            </>
        );
    }
}

const ReactiveCardComponent = withRouter(withFirebase(ReactiveCardComponentBase));

export default ReactiveCard;
export { ReactiveCardComponent };